import api from './axios';

export const getBillingOverviewApi = () => api.get('/admin/billing/overview');

export const getBillingAnalyticsApi = () => api.get('/admin/billing/analytics');

export const getRefundRequestsApi = (params = {}) => api.get('/admin/billing/refunds', { params });

export const createRefundRequestApi = (data) => api.post('/admin/billing/refunds', data);

export const approveRefundRequestApi = (id) => api.post(`/admin/billing/refunds/${id}/approve`);

export const rejectRefundRequestApi = (id, data) => api.post(`/admin/billing/refunds/${id}/reject`, data);

export const triggerCsvExportApi = (data) => api.post('/admin/billing/transactions/export', data);

export const getUserBillingHistoryApi = (userId) => api.get(`/admin/billing/users/${userId}`);
